<div class="content-header">
  Authorizers
</div>

<div class="header-helper">
  This lists the authorizers for the domain and their permissions to approve change requests.
</div>
<div class="grid-x" *ngIf="authPolicyViewable?.users.length>0">
  <div class="cell large-4 small-12 medium-6 content-sub-header">
    Name
  </div>
  <div class="cell large-1 medium-0 small-0"></div>

  <div class="cell large-7 small-12 medium-6 content-sub-header">
    Request Type
  </div>
</div>
<div class="grid-x" *ngFor="let user of authPolicyViewable?.users">
  <div class="cell large-4 small-12 medium-6" style="display: flex;">
    <lib-user-link [ngClass]="usersChange| defineDomainViewCss: user: 'authUsers'" [user]="user"></lib-user-link>
    <span class="text-helper wrap-text">&nbsp;&nbsp;{{user.email}}</span>
  </div>
  <div class="cell large-1 medium-0 small-0"></div>

  <div class="cell large-7 small-12 medium-6 bold-text">
    <span class="header-helper" [innerHTML]="user?.permissions | authPolicyHelper: 'permissions'"></span>
  </div>
</div>
<div class="content-header" style="margin-top: 24px !important;">
  Authorizations Needed
</div>

<div class="header-helper">
  This lists the thresholds for each change request type. The authorization policy can be set to: All -
  all authorizers in the group must approve; Majority - a majority of authorizers in the group
  must approve (50% of authorizers + 1); or Minimum - a set number, minimum, of authorizers must approve. If you select a minimum,
  you must make sure you have at least that number of authorizers for that request type group.
</div>
<div class="grid-x">
  <div class="cell large-2 small-12 medium-6 content-sub-header">
    Request Type
  </div>
  <div class="cell large-10 small-12 medium-6 content-sub-header ">
    Threshold
  </div>
</div>
<div class="grid-x" [ngClass]="policyChange| defineDomainViewCss: 'Control': 'policy'">
  <div class="cell large-2 small-12 medium-6 ">
    <label>Change of Control</label>
  </div>
  <div class="cell large-10 small-12 medium-6 bold-text">
    {{authPolicyViewable.policies | authPolicyHelper :'policy':'Control'}}
  </div>
</div>
<div class="grid-x" [ngClass]="policyChange| defineDomainViewCss: 'Non-Technical': 'policy'">
  <div class="cell large-2 small-12 medium-6">
    <label>Non-Technical</label>
  </div>
  <div class="cell large-10 small-12 medium-6 bold-text">
    {{authPolicyViewable.policies | authPolicyHelper :'policy':'Non-Technical'}}
  </div>
</div>
<div class="grid-x" [ngClass]="policyChange| defineDomainViewCss: 'Technical': 'policy'">
  <div class="cell large-2 small-12 medium-6">
    <label>Technical</label>
  </div>
  <div class="cell large-10 small-12 medium-6 bold-text">
   {{authPolicyViewable.policies | authPolicyHelper :'policy':'Technical'}}

  </div>
</div>
<div class="grid-x" [ngClass]="policyChange| defineDomainViewCss: 'AuthPolicy': 'policy'">
  <div class="cell large-2 small-12 medium-6">
    <label>Authorization Policy</label>
  </div>
  <div class="cell large-10 small-12 medium-6 bold-text">
    {{authPolicyViewable.policies | authPolicyHelper :'policy':'AuthPolicy'}}
  </div>
</div>
<div class="grid-x last-update-button-section">
  <label>{{lastchange | lastChange}}</label>
  <button *ngIf="!viewMode" class="iana-button" (click)="onEdit()" id="update" [disabled]="!(pendingRequestChangeID | checkNull)">Modify</button>
</div>
